module.exports = __webpack_public_path__ + "static/media/Image_2.271e8515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureBlock/images/Image_2.jpg
// module id = 847
// module chunks = 0